export default "__VITE_ASSET__Drh8cLkT__"